jQuery(function ($) {
    $('.cross-sells .single-product').on('change', function (event) {

        let quantity = $(this).find('.quantity input');
        let href = $(this).find('.button-input--shop').attr('href').replace(/quantity=\d+/, 'quantity=' + quantity.val());

        $(this).find('.button-input--shop').attr('data-quantity', quantity.val());
        $(this).find('.button-input--shop').attr('href', href);
    });

});